const recordingConsent = '為維護顧客與醫療人員安全、保障雙方權益，並於必要時協助釐清事件經過，特此告知安合癒境美學健康診所僅於公共區域及諮詢／問診室設有錄影設備。錄影資料僅供本診所授權人員於必要範圍內調閱，資料保存期限為40日，期限屆滿後將自動覆寫或刪除；如遇爭議、申訴、司法程序或主管機關調查，得於必要範圍內另行保存。治療室、更衣區及洗手間皆未設置錄影設備，您的隱私將受到妥善保護，請您安心。如不同意，請主動告知。我們會協助。'
export {
  recordingConsent,
};
